import gql from 'graphql-tag'

export const GET_USER_PREFERENCES = gql`
  query UserPreferences($filter: GetUserPreferencesFilter) {
    userPreferences(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      userPreferences {
        entityType
        fieldType
        label
        value
      }
      companyPreferences {
        entityType
        fieldType
        label
        value
      }
    }
  }
`

export const CREATE_USER_PREFERENCES = gql`
  mutation CreateUserPreference($input: CreateUserPreferenceInputType!) {
    createUserPreference(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createUserPreference {
        entityType
        fieldType
        label
        value
      }
    }
  }
`

export const UPDATE_USER_PREFERENCES = gql`
  mutation UpdateUserPreference($input: UpdateUserPreferenceInputType!) {
    updateUserPreference(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateUserPreference {
        entityType
        fieldType
        label
        value
      }
    }
  }
`
